import {inject, Injectable} from '@angular/core';
import {ApiCisternListResponseDto, ApiCisternRequestDto, ApiCisternResponseDto, CisternsApiService} from '@birco/rainmesh-api';
import {Observable} from 'rxjs';
import {CisternStateService} from '../api/cistern-state-service.interface';

@Injectable({
  providedIn: 'root'
})
export class CisternStateServiceImpl implements CisternStateService {
  private cisternsApiService = inject(CisternsApiService);

  getCistern(id: string): Observable<ApiCisternResponseDto | null> {
    return this.cisternsApiService.getCistern(id)
  }

  getCisterns(options: {
    searchTerm?: string,
    pageSize?: number,
    page?: number,
    sortBy?: string,
    sortDir?: string,
  }): Observable<ApiCisternListResponseDto> {
    return this.cisternsApiService.getCisterns(
      options.pageSize,
      options.page,
      options.sortBy,
      options.sortDir,
      options.searchTerm,
    );
  }

  createCistern(requestDto: ApiCisternRequestDto): Observable<ApiCisternResponseDto> {
    return this.cisternsApiService.createCistern(requestDto);
  }

  updateCistern(id: string, requestDto: ApiCisternRequestDto): Observable<ApiCisternResponseDto> {
    return this.cisternsApiService.updateCistern(id, requestDto);
  }

  deleteCistern(id: string): Observable<any> {
    return this.cisternsApiService.deleteCistern(id);
  }
}
